import { render, staticRenderFns } from "./btob.vue?vue&type=template&id=2b1357fa&scoped=true&"
import script from "./btob.vue?vue&type=script&lang=js&"
export * from "./btob.vue?vue&type=script&lang=js&"
import style0 from "./btob.vue?vue&type=style&index=0&id=2b1357fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1357fa",
  null
  
)

export default component.exports